import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

/**
 * 신규 본인인증 sdk에서 필요한 showDialog 인터페이스에 필요한 popup 컴포넌트
 * */
const PassAuthSdkPopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  if (!store?.sdkShowDialogState) return null;
  return (
    <Popup
      key={store.sdkShowDialogState.mainBtn.label}
      isOpen={store.sdkShowDialogState.isOpen}
      mainBtn={store.sdkShowDialogState.mainBtn}
      subBtn={store.sdkShowDialogState.subBtn}
    >
      {store.sdkShowDialogState?.children}
    </Popup>
  );
};

export default observer(PassAuthSdkPopup);
